export class Token {
    access_token: string;
    refresh_token: string;
    token_type: string;
    expires_in: number;
    loggedInSince: string;
    inCorrectLoginCount: number;
    displayName: string;
    globalRoleCode: string;
    userId: string;
    organisationRoleCode: string;
    needsSecretChanged: string;
    missingMobileOrDob: string;
    sso_isActivated: string;
    sso_isLinked: string;
    connection_names: string | string[]; // Backend may send as string or array
    
}


// WEBPACK FOOTER //
// ./src/app/models/token.ts